/* eslint-disable no-undefined */
import React from "react";
import PropTypes from "prop-types";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-boost";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloLink, fromPromise } from "apollo-link";
import ApolloLinkTimeout from "apollo-link-timeout";
//Limitless imporst
import { setGraphQLClient } from "./GraphQLClient";
import { createMutationHeaders } from "../utils/SecurePlatformAPIUtils";
import { log as pilog } from "@limitless/common/utils";
import { refreshToken } from "@limitless/expert/apis/authentication-api/AuthenticationAPI";
const GraphQLProvider = ({
  children,
  onUnauthorised,
  updateGraphReady
}) => {
  var _process$env$REACT_AP;
  const [hasConfiguredGraph, setHasConfiguredGraph] = React.useState(false);
  React.useEffect(() => {
    if (hasConfiguredGraph) {
      updateGraphReady();
    }
  }, [hasConfiguredGraph]);
  const timeoutLink = new ApolloLinkTimeout((_process$env$REACT_AP = process.env.REACT_APP_HTTP_POST_TIMEOUT) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 30000); // default 30 second timeout

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL
  });
  const timeoutHttpLink = timeoutLink.concat(httpLink);
  const withToken = setContext((_, {
    headers
  }) => {
    const log = pilog.getLogger("GraphQLProvider withToken");
    // return the headers to the context so httpLink can read them
    const authenticationHeaders = createMutationHeaders(null, headers);
    if (process.env.REACT_APP_GRAPHQL_API_KEY) {
      log.debug("Adding x-api-key to headers");
      authenticationHeaders.headers["x-api-key"] = process.env.REACT_APP_GRAPHQL_API_KEY;
    }
    return authenticationHeaders;
  });
  const resetToken = onError(({
    networkError,
    operation,
    forward
  }) => {
    const log = pilog.getLogger("GraphQLProvider resetToken");
    if (networkError && networkError.statusCode === 401) {
      return fromPromise(refreshToken().catch(e => {
        onUnauthorised();
        log.warn("Unauthorised %o", e);
      })).filter(value => Boolean(value)).flatMap(tokeData => {
        var _tokeData$idToken;
        if ((_tokeData$idToken = tokeData.idToken) !== null && _tokeData$idToken !== void 0 && _tokeData$idToken.jwtToken) {
          var _tokeData$idToken2;
          const oldHeaders = operation.getContext().headers;
          // modify the operation context with a new token
          operation.setContext({
            headers: {
              ...oldHeaders,
              Authorization: (_tokeData$idToken2 = tokeData.idToken) === null || _tokeData$idToken2 === void 0 ? void 0 : _tokeData$idToken2.jwtToken
            }
          });

          // retry the request, returning the new observable
          return forward(operation);
        } else {
          onUnauthorised();
          return null;
        }
      });
    }
    return null;
  });
  const cleanTypeName = new ApolloLink((operation, forward) => {
    if (operation.variables) {
      const omitTypename = (key, value) => key === "__typename" ? undefined : value;
      operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    }
    return forward(operation).map(data => {
      return data;
    });
  });
  const authFlowLink = withToken.concat(resetToken);
  const graphQLClient = new ApolloClient({
    // link: concat(authFlowLink, httpLink, cleanTypeName),
    cache: new InMemoryCache(),
    link: ApolloLink.from([cleanTypeName, authFlowLink, timeoutHttpLink])
  });
  setGraphQLClient(graphQLClient);
  if (!hasConfiguredGraph) {
    setHasConfiguredGraph(true);
  }
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: graphQLClient
  }, children);
};
export default GraphQLProvider;
GraphQLProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onUnauthorised: PropTypes.func.isRequired,
  updateGraphReady: PropTypes.func.isRequired
};